import { GlassPanel } from "@/components/ui/glass-panel"

export function GlassPanelSection() {
  return (
    <section id="glass-panel" className="scroll-mt-20 border-b py-12">
      <h2>Glass panel</h2>
      <p className="mt-3 max-w-3xl text-muted-foreground">Use glass for orientation, summaries, navigation, and layered comparisons. Keep tables, long forms, BOQs, payroll, and dense financial records on opaque surfaces.</p>
      <div className="relative mt-8 grid gap-4 overflow-hidden rounded-2xl bg-foreground p-6 sm:grid-cols-2">
        <div className="absolute -right-16 -top-16 size-64 rounded-full bg-primary/40 blur-[80px]" />
        <GlassPanel className="p-6"><p className="text-xs text-muted-foreground">Default</p><h3 className="mt-8">Working summary</h3><p className="mt-2 text-sm text-muted-foreground">A refracted surface over a quiet ambient field.</p></GlassPanel>
        <GlassPanel tone="dark" className="p-6"><p className="text-xs text-background/55">Dark</p><h3 className="mt-8 text-background">Decision context</h3><p className="mt-2 text-sm text-background/60">High contrast while retaining depth behind the panel.</p></GlassPanel>
      </div>
    </section>
  )
}
